import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import { type ImportModalEvent } from '../types';

export const useTrackClickedSwitchImportAccount = () => {
  const { track } = useAnalyticsUtilities();

  const trackClickedSwitchImportAccount = useCallback(
    (params: ImportModalEvent) => {
      track(`Clicked Switch Account in Import Modal`, params);
    },
    [track],
  );

  return { trackClickedSwitchImportAccount };
};
